export type ActiveWorkRecord = {
  id: string;
  status?: string | null;
  reference_code?: string | number | null;
  vehicle_name?: string | null;
  issue_date?: string | null;
  driver_first_name?: string | null;
  driver_last_name?: string | null;
};

type WorkOrderGroups = {
  results: { status?: string; work_orders: ActiveWorkRecord[] }[];
};

export const issueDateTime = (value?: string | null): number | null => {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(timestamp) &&
    new Date(timestamp).toISOString().slice(0, 10) === value
    ? timestamp
    : null;
};

/** Preserve unknown active statuses; missing issue dates sort after dated work. */
export const getActiveWork = (data: WorkOrderGroups): ActiveWorkRecord[] =>
  data.results
    .flatMap((group) =>
      group.work_orders.map((record) => ({
        ...record,
        status: record.status || group.status || null,
      })),
    )
    .filter((record) => record.status?.toLowerCase() !== "completed")
    .sort((a, b) => {
      const aDate = issueDateTime(a.issue_date);
      const bDate = issueDateTime(b.issue_date);
      if (aDate === null) return bDate === null ? 0 : 1;
      if (bDate === null) return -1;
      return aDate - bDate;
    });

export const formatIssueDate = (value?: string | null): string => {
  const timestamp = issueDateTime(value);
  return timestamp === null
    ? "Date not recorded"
    : new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      }).format(timestamp);
};

export const workStatus = (status?: string | null) =>
  !status || status === "unknown"
    ? "Status unavailable"
    : status.replace(/_/g, " ");

export const filterActiveWork = (
  records: ActiveWorkRecord[],
  status: string,
  query: string,
) => {
  const search = query.trim().toLocaleLowerCase();
  return records.filter(
    (record) =>
      (status === "all" || (record.status || "unknown") === status) &&
      (!search ||
        [
          record.reference_code,
          record.vehicle_name,
          record.driver_first_name,
          record.driver_last_name,
        ]
          .filter((value) => value != null)
          .join(" ")
          .toLocaleLowerCase()
          .includes(search)),
  );
};
